import React, { useEffect } from "react";
import { Box } from "@mantine/core";
import { Title } from "@jasper/shared/stories/Title/Title";
import { ButtonRadioSelect } from "@jasper/shared/stories/ButtonRadioSelect/ButtonRadioSelect";
import { Controller, useFormContext } from "react-hook-form";
import { Product, WorkflowType } from "@jasper/shared";

export const PartialDentureWorkflow: React.FC<{
  product: Product;
}> = ({ product }) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (product.removableItem?.[0]?.workflowType) {
      setValue("workflow", product.removableItem[0].workflowType);
    }
  }, [product]);

  return (
    <Box pt="lg">
      <Title
        title="Flux de travail"
        size={3}
        mb="md"
      />
      <Controller
        control={control}
        name="workflow"
        rules={{ required: "Veuillez sélectionner un flux de travail" }}
        render={({ field }) => (
          <ButtonRadioSelect
            gridTemplateColumns="repeat(1, 1fr)"
            position="left"
            options={[
              {
                label: "Finition directe - 1 RDV",
                value: WorkflowType.ONE_APPOINTMENT_DIRECT,
                description:
                  "Vous recevez la prothèse partielle finie au prochain rendez-vous",
              },
              {
                label: "Essayage avec montage des dents en cire  - 2 RDV",
                value: WorkflowType.WITH_FITTING,
                description:
                  "Vous recevez l’essayage de la prothèse partielle avec montage des dents en cire au prochain rendez-vous.",
              },
              {
                label: "Cire(s) d’occlusion - 2 à 3 RDV",
                value: WorkflowType.WAX_RIM,
                description:
                  "Vous recevez au prochain RDV la ou les cire(s) d’occlusion (sur châssis métallique dans le cas d’un stellite).",
              },
            ]}
            setSelected={value => field.onChange(value as string)}
            selected={field.value}
            label="Comment souhaitez-vous procéder ?"
          />
        )}
      />
      {errors.workflow && (
        <span style={{ color: "red", fontSize: "14px" }}>
          {errors.workflow?.message as string}
        </span>
      )}
    </Box>
  );
};
